/**
 * StaffInfo 类型和 Schema 定义
 *
 * ⚠️ 注意: 此文件由脚本自动生成，请勿手动修改
 * 如需更新，请运行代码生成脚本
 */
import type { SchemaDefinition } from './_schema'

/**
 * StaffInfo
 */
export interface StaffInfo {
  /** 创建时间（UTC） */
  created_at?: string
  /** 更新时间（UTC） */
  updated_at?: string
  /** 主键（UUID4），全局唯一，不可重复，36位 */
  id?: string
  /** 删除时间（UTC），goframe会自动处理deleted_at，如果想避免goframe自动处理，请使用Unscoped() */
  deleted_at?: string
  /** 删除原因 */
  deleted_reason?: string
  /** 禁用状态 */
  disabled?: boolean
  /** 禁用时间 */
  disabled_at?: string
  /** 禁用截止时间（null表示永久禁用） */
  disabled_until?: string
  /** 禁用原因 */
  disabled_reason?: string
  /** 用户名，全局唯一，用于登录 */
  username?: string
  /** 是否设置了密码 */
  has_password?: boolean
  /** 员工昵称，可重复 */
  nickname?: string
  /** 员工简介 */
  bio?: string
  /** 是否超级管理员（拥有所有权限） */
  is_super_admin?: boolean
  /** 最后登录时间（UTC） */
  last_login_at?: string
}

/**
 * StaffInfo Schema
 */
export const StaffInfoSchema: SchemaDefinition = {
  properties: {
    created_at: {
      description: '创建时间（UTC）',
      format: '*time.Time',
      type: 'string',
      label: '创建时间',
    },
    updated_at: {
      description: '更新时间（UTC）',
      format: '*time.Time',
      type: 'string',
      label: '更新时间',
    },
    id: {
      description: '主键（UUID4），全局唯一，不可重复，36位',
      format: 'string',
      type: 'string',
      label: '主键',
    },
    deleted_at: {
      description:
        '删除时间（UTC），goframe会自动处理deleted_at，如果想避免goframe自动处理，请使用Unscoped()',
      format: '*time.Time',
      type: 'string',
      label: '删除时间',
    },
    deleted_reason: {
      description: '删除原因',
      format: 'string',
      type: 'string',
      label: '删除原因',
    },
    disabled: {
      description: '禁用状态',
      format: 'bool',
      type: 'boolean',
      label: '禁用状态',
    },
    disabled_at: {
      description: '禁用时间',
      format: '*time.Time',
      type: 'string',
      label: '禁用时间',
    },
    disabled_until: {
      description: '禁用截止时间（null表示永久禁用）',
      format: '*time.Time',
      type: 'string',
      label: '禁用截止时间',
    },
    disabled_reason: {
      description: '禁用原因',
      format: 'string',
      type: 'string',
      label: '禁用原因',
    },
    username: {
      description: '用户名，全局唯一，用于登录',
      format: 'string',
      type: 'string',
      label: '用户名',
    },
    has_password: {
      description: '是否设置了密码',
      format: 'bool',
      type: 'boolean',
      label: '是否设置了密码',
    },
    nickname: {
      description: '员工昵称，可重复',
      format: 'string',
      type: 'string',
      label: '员工昵称',
    },
    bio: {
      description: '员工简介',
      format: 'string',
      type: 'string',
      label: '员工简介',
    },
    is_super_admin: {
      description: '是否超级管理员（拥有所有权限）',
      format: 'bool',
      type: 'boolean',
      label: '是否超级管理员',
    },
    last_login_at: {
      description: '最后登录时间（UTC）',
      format: '*time.Time',
      type: 'string',
      label: '最后登录时间',
    },
  },
  type: 'object',
}
